import { login } from '@edu-fe/login'
import api from './api'
import { pick } from './utils'

/**
 * 微信内下单接口
 *
 * @param {Object} params 参数
 * @param {String} params.couponId 优惠券id
 * @param {String} params.courseId 商品id
 * @param {String} params.groupId 参团id
 * @param {Number} params.payWay 下单方式, 9:支付宝 | 10:微信支付
 * @param {String} params.from 订单来源
 * @param {Number} params.isSend 是否是赠送, 1:是 | 0:不是
 * @param {Number} params.theme 赠送主题
 * @param {Number} params.type 商品类型, 1:课程 | 2:专题
 * @param {String} params.wpsSid 用户id
 * @param {String} params.thirdSession 小程序用户信息
 * @param {String} params.token 分享唯一标示
 * @return {Promise} 接口返回信息 { giftId }
 */
export default async function pay (params) {
  const { code, data } = await api.PackageEduFePay.weixin(params)

  // 处理支付未登录
  if (code < 0) {
    return login().then(() => params)
  }

  const wxPayData = pick(data, [
    'timestamp',
    'nonceStr',
    'package',
    'signType',
    'paySign',
    'appId'
  ])

  wxPayData.timeStamp = data.timestamp // 兼容微信支付旧api
  wxPayData.fail = params.failCallback
  wxPayData.cancel = params.cancelCallback

  window.WeixinJSBridge.invoke('getBrandWCPayRequest', wxPayData, res => {
    if (/fail$/.test(res.err_msg)) {
      params.failCallback()
    } else if (/cancel$/.test(res.err_msg)) {
      params.cancelCallback()
    }
  })

  return pick(data, ['orderId'])

  // return new Promise((resolve, reject) => {
  //   wxPayData.success = () => {
  //     resolve(pick(data, ['orderId'])) // 目前只用到 orderId, 保持 resultData 干净
  //     window.alert(111111)
  //   }
  //   wxPayData.fail = res => reject(res)
  //   wxPayData.cancel = res => reject(res)
  //   // window.wx.requestPayment(wxPayData)
  //   // window.wx.chooseWXPay(wxPayData)
  //   window.WeixinJSBridge.invoke(
  //     'getBrandWCPayRequest',
  //     wxPayData
  //   )
  // })
}
